import React from "react";
import { getInstantValidationState } from '../../../utils/realTimeValidationUtils';

import './StandardPreOp.scss';

const StandardPreOp = ({ handleFormData, values, fieldErrors = {}, touchedFields = {} }) => {
  return (
    <div className="modern-assessment">
      <h2 className="assessment-title">Standaard Pre-operatief Formulier</h2>
      {(() => {
        const validation = getInstantValidationState('spreop.spreopQuestion1', fieldErrors, touchedFields, values.spreop.spreopQuestion1);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              1. Verwacht u een afname van de pijn als direct resultaat na de geplande operatie/behandeling?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="spreopQuestion1"
              required
              value={values.spreop.spreopQuestion1}
              onChange={(event) => handleFormData("spreop", "spreopQuestion1", event.target.value)}
              aria-label="Verwachting pijnafname na operatie"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}    

      {(() => {
        const validation = getInstantValidationState('spreop.spreopQuestion2', fieldErrors, touchedFields, values.spreop.spreopQuestion2);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              2. Verwacht u een verbetering qua beweging en kracht van het aangedane gewricht als direct resultaat na de geplande operatie/behandeling?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="spreopQuestion2"
              required
              value={values.spreop.spreopQuestion2}
              onChange={(event) => handleFormData("spreop", "spreopQuestion2", event.target.value)}
              aria-label="Verwachting verbetering beweging en kracht"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('spreop.spreopQuestion3', fieldErrors, touchedFields, values.spreop.spreopQuestion3);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              3. Verwacht u de normale activiteiten in het dagelijks leven weer op te kunnen pakken als direct resultaat na de geplande operatie/behandeling?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="spreopQuestion3"
              required
              value={values.spreop.spreopQuestion3}
              onChange={(event) => handleFormData("spreop", "spreopQuestion3", event.target.value)}
              aria-label="Verwachting terugkeer normale dagelijkse activiteiten"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}
      
      {(() => {
        const validation = getInstantValidationState('spreop.spreopQuestion4', fieldErrors, touchedFields, values.spreop.spreopQuestion4);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              4. Verwacht u de normale functioneren in sportieve activiteiten weer op te kunnen pakken als direct resultaat na de geplande operatie/behandeling?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="spreopQuestion4"
              required
              value={values.spreop.spreopQuestion4}
              onChange={(event) => handleFormData("spreop", "spreopQuestion4", event.target.value)}
              aria-label="Verwachting terugkeer sportieve activiteiten"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
              <option value="Niet van toepassing - Ik doe niet aan sport">Niet van toepassing - Ik doe niet aan sport</option>
            </select>
            
          </div>
        );
      })()}
    </div>
  );
}

export default StandardPreOp;
